// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftPanel {
    width: 30%;
    align-self: center;
}

.togglemeasuredef{
    align-self: flex-start;
    margin-bottom: 10px;
}

.togglemeasuredef .mat-button-toggle-checked {
    background-color: lightgray;
}

.togglemeasuredef mat-button-toggle {
    background-color: transparent;
}

.mat-tab-group {
    height: 100%;
}

.filterpanel {
    padding: 20px;
}

/*.mat-tab-body-wrapper {
    flex-grow: 1;
}

.mat-tab-body {
    display: flex !important;
    flex-direction: column;
}

.mat-tab-body-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}*/
`, "",{"version":3,"sources":["webpack://./src/app/components/objectcreator/measuredefinition/measuredef.control.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;;;;;;;;;;EAaE","sourcesContent":[".leftPanel {\n    width: 30%;\n    align-self: center;\n}\n\n.togglemeasuredef{\n    align-self: flex-start;\n    margin-bottom: 10px;\n}\n\n.togglemeasuredef .mat-button-toggle-checked {\n    background-color: lightgray;\n}\n\n.togglemeasuredef mat-button-toggle {\n    background-color: transparent;\n}\n\n.mat-tab-group {\n    height: 100%;\n}\n\n.filterpanel {\n    padding: 20px;\n}\n\n/*.mat-tab-body-wrapper {\n    flex-grow: 1;\n}\n\n.mat-tab-body {\n    display: flex !important;\n    flex-direction: column;\n}\n\n.mat-tab-body-content {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
